import { render, staticRenderFns } from "./AllRemindTask.vue?vue&type=template&id=29357940&scoped=true"
import script from "./AllRemindTask.vue?vue&type=script&lang=js"
export * from "./AllRemindTask.vue?vue&type=script&lang=js"
import style0 from "./AllRemindTask.vue?vue&type=style&index=0&id=29357940&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29357940",
  null
  
)

export default component.exports